/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N2Inputs */

const en_csv_to_json_ref_n2 = /** @type {(inputs: Csv_To_Json_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A doubled double quote inside a quoted field becomes one literal quote.`)
};

const ko_csv_to_json_ref_n2 = /** @type {(inputs: Csv_To_Json_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용 필드 안의 두 개짜리 큰따옴표는 리터럴 따옴표 하나가 됩니다.`)
};

const ja_csv_to_json_ref_n2 = /** @type {(inputs: Csv_To_Json_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用フィールド内の 2 つ続いた二重引用符はリテラルの引用符 1 つになります。`)
};

/**
* | output |
* | --- |
* | "A doubled double quote inside a quoted field becomes one literal quote." |
*
* @param {Csv_To_Json_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n2 = /** @type {((inputs?: Csv_To_Json_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n2(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n2(inputs)
	return ja_csv_to_json_ref_n2(inputs)
});